// extracted by mini-css-extract-plugin
module.exports = {"addTo_btn_action":"AddTo_addTo_btn_action__I4rw1","addTo_btn":"AddTo_addTo_btn__3i5ah","addTo_img":"AddTo_addTo_img__3k7pM","addTo_link":"AddTo_addTo_link__3AFJv"};